export default "__VITE_ASSET__CthUbhvm__"